
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import contactUs from '../Assets/images/contact-us.jpeg';
import { useForm } from 'react-hook-form';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import { toast } from "react-toastify";

function ContactUs(props) {

    const { 
        register, 
        handleSubmit, 
        getValues,
        reset,
        formState: { errors }, 
    } = useForm(); 

    const onSubmit = useCallback(() => { 
        const data = getValues(); 
        const SumbitInquiryForm = Promise.resolve(PostApiWithoutLogin(API_PATH.NewInquiry, data));
        SumbitInquiryForm.then(response => {
            if(response.status === 200){
                toast.success("Message recived. We will get back to you ASAP!");
                reset();
            } else toast.error("Could not send your message. Try again later!");
        })
    }, [getValues]); 

    return (
        <section className='container common-space-both' id="contact">
                <div className='common-title'>
                    <h2>Contact Us</h2>
                    <p>Have questions or need assistance? We're here to help! Get in touch with us for business inquiries, support, or partnership opportunities. <br/>Our team is ready to assist you.</p>
                </div>
                <div className='grid grid-cols-4 mt-4 gap-10 mobile:place-items-center'>
                    <div className='common-title col-span-3 mobilexl:col-span-full'>
                        <h3>We’re always here for you</h3>
                        <span>Need to know more on details? <Link to={'tel:+91 79908 88360'} className='text-[#F0643B] underline'>Call Us +91 79908 88360</Link></span>

                        <form className='mt-4 flex flex-col gap-3 mobilexl:gap-3' onSubmit={handleSubmit(onSubmit)}>
                            <div className='grid grid-cols-2 gap-3 mobilexl:grid-cols-1 mobilexl:gap-3'>
                                <div>
                                    <lable className='cust-label mb-2'>First Name</lable>
                                    <input 
                                        type='text' 
                                        placeholder='Enter your first name' 
                                        {...register("firstname", { required: "Please Enter Your First Name" })}
                                    />
                                </div>
                                <div>
                                    <lable className='cust-label mb-2'>Last Name</lable>
                                    <input 
                                        type='text' 
                                        placeholder='Enter your last name'
                                        {...register("lastname", { required: "Please Enter Your Last Name" })} 
                                    />
                                </div>
                            </div>
                            <div>
                                <lable className='cust-label mb-2'>Email Address</lable>
                                <input 
                                    type='email' 
                                    placeholder='Enter your email address'
                                    {...register("email", { required: "Please Enter Your Email" })} 
                                />
                            </div>
                            <div>
                                <lable className='cust-label mb-2'>Message</lable>
                                <textarea 
                                    placeholder='Write your message...'
                                    {...register("message")} 
                                ></textarea>
                            </div>
                            <div className='text-end mobilexl:text-center'>
                                <button type='submit' className='btn-common mobilexl:w-full'>Inquire</button>
                            </div>
                        </form>
                    </div>
                    <div className='col-span-1 mobilexl:col-span-4 '>
                        <img src={contactUs} className='img-fluid rounded-xl' alt='contact us' />
                    </div>
                </div>
            </section>
    );
}

export default ContactUs;